import { forwardRef, useState } from 'react'
import InputBase from '@mui/material/InputBase'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useTheme } from '@mui/material/styles'

const AdxInput = forwardRef(
  (
    {
      label,
      subLabel,
      size,
      errorMessage,
      sx,
      sxLabel,
      sxSubLabel,
      sxInput,
      charLimit,
      inputProps,
      disabled,
      isErrorShown,
      errorTextAlign,
      ...rest
    },
    ref
  ) => {
    const { value } = rest

    const { typography, componentHeight, palette } = useTheme()
    let fontSize
    let minHeight
    let paddingX

    switch (size) {
      case 'standard':
        fontSize = typography.body1.fontSize
        paddingX = typography.body1.fontSize
        minHeight = componentHeight.standard
        break
      case 'large':
        fontSize = typography.h4.fontSize
        paddingX = typography.h4.fontSize
        minHeight = componentHeight.large
        break
      default:
        fontSize = typography.body1.fontSize
        paddingX = typography.body1.fontSize
        minHeight = componentHeight.standard
    }

    const defaultProps = () => {
      return {
        fontSize: `${fontSize}px !important`,
        paddingX,
        minHeight,
        borderRadius: `4.5px`,
        '&. MuiInputBase-input': {
          fontSize: 50,
        },
        outlineColor: isErrorShown ? palette.error.main : null,
      }
    }

    // state to count number of character
    const [charCount, setCharCount] = useState(value?.length || 0)

    return (
      <Box
        width={1}
        display={'flex'}
        flexDirection={'column'}
        rowGap={label ? 1 : null}
        sx={{ ...sx }}
      >
        {label || subLabel ? (
          <Box display="flex" justifyContent="space-between" alignItems="center">
            {label ? (
              <Typography
                variant="body1"
                sx={{
                  color: disabled ? 'gray-inactive-button.main' : 'dark-text.main',
                  ...sxLabel,
                }}
              >
                {label}
              </Typography>
            ) : null}
            {subLabel ? (
              <Typography
                variant="body1"
                sx={{
                  color: disabled ? 'gray-inactive-button.main' : 'light-gray-text.main',
                  ...sxSubLabel,
                }}
              >
                {subLabel}
              </Typography>
            ) : null}
          </Box>
        ) : null}
        <Box>
          <InputBase
            disabled={disabled}
            fullWidth
            inputProps={{ maxLength: charLimit, ...inputProps }}
            {...rest}
            sx={{ ...defaultProps(), ...sxInput }}
            onInput={(event) => {
              const { value } = event.target || ''
              setCharCount(value.length)
            }}
            ref={ref}
            className="scrollbar"
          />
          <Box pt={isErrorShown && errorMessage && 0.5} textAlign={errorTextAlign}>
            {isErrorShown && errorMessage}
            {charLimit && !isErrorShown && (
              <Box display="flex" justifyContent="flex-end" marginTop={'8px'}>
                <Typography variant="body2" color="light-gray-text.main">
                  {`${charCount}/${charLimit}`}
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    )
  }
)

export default AdxInput
